"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListInvitationsQuerySchema = exports.TeamInvitationIdParamsSchema = exports.AnswerInvitationBodySchema = exports.UpdateInvitationBodySchema = exports.CreateInvitationBodySchema = exports.ListUserInvitationsResponseSchema = exports.ListInvitationsResponseSchema = exports.UpdateInvitationResponseSchema = exports.CreateInvitationResponseSchema = exports.GetUserInvitationResponseSchema = exports.GetInvitationResponseSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("../common");
/**
 * Responses
 */
exports.GetInvitationResponseSchema = common_1.InvitationSchema;
exports.GetUserInvitationResponseSchema = common_1.InvitationSchema;
exports.CreateInvitationResponseSchema = common_1.InvitationSchema;
exports.UpdateInvitationResponseSchema = common_1.InvitationSchema;
exports.ListInvitationsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.GetInvitationResponseSchema);
exports.ListUserInvitationsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.GetUserInvitationResponseSchema);
/**
 * Body
 */
exports.CreateInvitationBodySchema = (0, core_1.StrictObject)({
    userId: typebox_1.Type.Optional(core_1.IdSchema),
    email: typebox_1.Type.Optional(core_1.EmailSchema),
    role: ruby_1.TeamRoleSchema,
});
exports.UpdateInvitationBodySchema = (0, core_1.StrictObject)({
    role: typebox_1.Type.Optional(ruby_1.TeamRoleSchema),
});
exports.AnswerInvitationBodySchema = (0, core_1.StrictObject)({
    accepted: typebox_1.Type.Boolean({
        title: "Accepted",
        description: "Whether the invitation was accepted or not",
    }),
});
/**
 * Parameters
 */
exports.TeamInvitationIdParamsSchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    invitationId: core_1.IdSchema,
}, {
    title: "Team and Invitation",
    description: "Combined Team and Invitation Id in a query parameter",
});
exports.ListInvitationsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
